<dialog #dialog class="gli-modal" closedby="none" aria-modal="true"
  aria-labelledby="gli-processing-title" aria-describedby="gli-processing-message"
  (cancel)="$event.preventDefault()">
  <div class="flex min-h-full items-center justify-center">
    <div class="kt-card w-full max-w-md bg-background shadow-xl" aria-busy="true">
      <div class="kt-card-content flex flex-col items-center gap-4 px-5 py-7 text-center">
        <span class="size-10 animate-spin rounded-full border-4 border-primary/25 border-t-primary"
          aria-hidden="true"></span>
        <h2 id="gli-processing-title" class="text-lg font-semibold text-mono" tabindex="-1" autofocus>{{ title() }}</h2>
        <p id="gli-processing-message" class="text-sm text-secondary-foreground" role="status" aria-live="polite">{{ message() }}</p>
      </div>
    </div>
  </div>
</dialog>
